module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry2"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("Gasoline Prices Expected to Climb Higher")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry3"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02"
    }
  }, [_vm._v("Tucson: The Mirror Lab")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry4"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter03"
    }
  }, [_vm._v("Palo Alio: Calvin Research Center")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry5"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter04"
    }
  }, [_vm._v("Redwood City: Days Inn")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry6"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter05"
    }
  }, [_vm._v("Melvin Calvin")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry7"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter06"
    }
  }, [_vm._v("Tucson: Steward Observatory\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry8"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter07"
    }
  }, [_vm._v("Palo Alto: Cochrane Residence\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry9"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Palo Alto: Marriott Residence Inn")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Palo Alto: Calvin Research Center")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greenhouse Gases Cause Rising Global Temperature")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manhattan: Waldorf - Astoria Hotel")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Student Recreation Center")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Las Casita De Molina")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Sunrise Apartments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Bmaa\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brain-Destroying Algae")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oracle, Arizona: Biosphere 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry19"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cessna Citation VII: 38,000 Feet Above Nebraska")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry20"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Sunrise Apartments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry21"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White House Calls For New Technology As Solution To Energy Problems")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry22"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Police Headquarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry23"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Sunrise Apartments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry24"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Sunrise Apartments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry25"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is It Time To Shoot For The Sun?")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry26"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arlington: Cambridge Savings Bank")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry27"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revere: Four Points Sheraton Hotel")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry28"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("America West Flight 64: Boston To Tucson")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry29"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Sunrise Apartments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry30"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dallas: Gould Energy Corporation Headquarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry31"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Sunrise Apartments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry32"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hydrogen Fuel Storage For Automobiles")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry33"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Arizona Inn")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry34"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manhattan: Gould Tower")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry35"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manhattan: Gould Trust Headquarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry36"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is Hydrogen Clean?")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry37"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interstate 95: Bridgeport, Connecticut")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry38"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston: Isabella Stewart Gardner Museum")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry39"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hybrid Sales Lag")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry40"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston: Top of the Pru Restaurant")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry41"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Palo Alto: Calvin Research Center")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry42"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manhattan: Gould Trust Headquarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry43"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston: Isabella Stewart Gardner Museum")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry44"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fuel for Thought")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry45"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washington, D.C.: Old Ebbitt Grill")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry46"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washington, D.C.: Dirksen Senate Office Building")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry47"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washington, D.C.: J.W. Marriott Hotel")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry48"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washington, D.C.: Senator Bardarson’s Office")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry49"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washington, D.C.: National Academy Of Sciences")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry50"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New York: United Nations Secretariat Building")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry51"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washington, D.C.: Georgetown University")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry52"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washington, D.C.: J.W. Marriott Hotel")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry53"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Catch-22 for Lite Fuel")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry54"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philadelphia: The Franklin Institute")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry55"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washington, D.C.: J.W. Marriott Hotel")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry56"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interstate 95: Delaware Memorial Bridge\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry57"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manhattan: Gould Trust Headquarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry58"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washington, D.C.: J.W. Marriott Hotel")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry59"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Local Man’s Car Gets 250 Mpg")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry60"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dulles, Virginia: Dulles International Airport")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry61"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cabo San Lucas: Hotel De Las Flores")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry62"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cabo San Lucas: Hotel De Las Flores")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry63"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Novel Reaction Produces Hydrogen")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry64"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manhattan: Gould Trust Headquarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry65"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manhattan: Gould Trust Headquarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry66"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manhattan: Gramercy Park Hotel")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry67"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Palo Alto: Calvin Research Center")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry68"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("San Francisco: Russian Hill")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry69"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manhattan: Gould Trust Headquarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry70"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Palo Alto: Calvin Research Center")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry71"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Palo Alto: Calvin Research Center Parking Lot")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry72"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Sunrise Apartments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry73"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson International Airport")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry74"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucson: Police Headquarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry75"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Las Vegas: Mccarran International Airport")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry76"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gould Trust To Acquire Calvin Research Center")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry77"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("San Francisco: Russian Hill\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry78"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Terrorist Scandal Hits Unesco Official")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry79"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("San Francisco: Russian Hill")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry80"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Palo Alto: Calvin Research Center")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry81"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manhattan: Gould Trust Headquarters\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry82"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gould Energy Corp. Confirms Hydrogen Fuel Breakthrough")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry83"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ua Professor Killed In Hit-And-Run Accident")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 87
// module chunks = 0